import { useSelector } from 'react-redux';
import ClientApiScreens from '../../../Data/ClientApiScreens';
import { selectCurrentScreen } from '../../../Helpers/clientApiJourneyPosition.helpers';
import useClientApiCopy from './useClientApiCopy';

// The one place the location step's copy block is chosen. Today the signal is
// the screen id; a future Capture-driven source swaps only this line.
const blockForScreen = (screenId) =>
  screenId === ClientApiScreens.ADDRESS_LIST ? 'address' : 'store';

const useLocationStepCopy = () => {
  const copy = useClientApiCopy();
  const screenId = useSelector((store) => selectCurrentScreen(store)?.screenId);
  return copy[blockForScreen(screenId)];
};

export default useLocationStepCopy;
